<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>sort</md-icon>
          </div>
          <h4 class="title">{{ $t("tutorial.edit.title") }}</h4>
        </md-card-header>

        <md-card-content>
          <!-- Url -->
          <md-field :class="{'md-error': $v.tutorialModel.url.$error && $v.tutorialModel.url.$invalid, 'md-valid': !$v.tutorialModel.url.$error && !$v.tutorialModel.url.$invalid}">
            <label>{{ $t("tutorial.edit.url") }}</label>
            <md-input v-model.trim="$v.tutorialModel.url.$model"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.tutorialModel.url.$error && $v.tutorialModel.url.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.tutorialModel.url.$error && !$v.tutorialModel.url.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </md-card-content>

        <md-card-actions class="actions">
          <md-button @click="setTutorial()" class="md-info" :disabled="loading">
            <span>{{ $t("tutorial.edit.save") }}</span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div> 
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      loading: true,
      tutorialModel: {
        url: ''
      }
    }
  },
  async mounted() {
    this.tutorialModel.url = await this.$store.dispatch("tutorialGet")
    this.loading = false;
  },
  methods: {
    async setTutorial() {
      await this.$store.dispatch("tutorialSet", {value: this.tutorialModel.url})
      this.$notify({
        message: this.$t(`notifications.tutorial.save`),
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success'
      })
    }
  },
  validations: {
    tutorialModel: {
      url: { }
    }
  }
}
</script>

<style>

</style>